import * as THREE from "three";
import type { FragModelInput } from "./types";

export const DEBUG_FRAG_VIEWER = false;
export const FLOOR_CLIP_BOTTOM_TOLERANCE_M = 0.08;
export const FLOOR_CLIP_TOP_TOLERANCE_M = 0.3;
export const IDLE_PIXEL_RATIO_CAP = 1.15;
export const INTERACTION_PIXEL_RATIO_CAP = 0.8;

export const debugLog = (...args: unknown[]) => {
  if (DEBUG_FRAG_VIEWER) console.log(...args);
};

export const fmt3 = (v: THREE.Vector3) =>
  `(${v.x.toFixed(2)}, ${v.y.toFixed(2)}, ${v.z.toFixed(2)})`;

export const getModelInputId = (input: FragModelInput): string => input.modelId ?? input.name;

export const yieldToBrowser = () =>
  new Promise<void>((resolve) => {
    window.setTimeout(resolve, 0);
  });

export const getCappedPixelRatio = (devicePixelRatio: number | undefined, cap: number) =>
  Math.min(devicePixelRatio || 1, cap);

export const getRetainedModelIds = (
  loadedModelIds: Iterable<string>,
  loadingModelIds: Iterable<string>
) => {
  const ids = new Set<string>(loadedModelIds);
  for (const modelId of loadingModelIds) ids.add(modelId);
  return [...ids];
};
